document.addEventListener("DOMContentLoaded", () => {
    function logShare(provider, url, result) {
        $.ajax({
            url: '/api/log/kpi',
            type: 'POST',
            data: { kpiValue: "share_" + provider + (result == 1 ? "_success" : "") },
            success: function (data) {
            },
            error: function (data) {
            }
        });

        let msgId = "";
        switch (provider) {
            case 'facebook':
                msgId = "ShFb";
                break;
            case 'twitter':
                msgId = "ShTw";
                break;
            case 'pinterest':
                msgId = "ShPt";
                break;
        }

        const splittedUrl = url.split('/');
        const simpleUrl = splittedUrl[splittedUrl.length - 2] + '/' + splittedUrl[splittedUrl.length - 1];

        $.ajax({
            url: '/api/log/sql',
            type: 'POST',
            data: { messageId: msgId, message: simpleUrl, data: result },
            success: function (data) {
            },
            error: function (data) {
            }
        });
    }

    if (window.twttr) {
        twttr.ready(
            function (twttr) {
                twttr.events.bind('click', function (ev) {
                    logShare("twitter", $(ev.target).data("url"), 0);
                });
            }
        );
    }

    if (window.FB) {
        FB.init({
            appId: document.querySelector("meta[property='fb:app_id']").getAttribute("content"),
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v14.0'
        });

        $(".fb-share-button").click((e) => {
            const $this = $(e.currentTarget);
            const href = $this.data("href");
            logShare("facebook", href, 0);
            FB.ui(
                {
                    method: 'share',
                    href: href,
                    hashtag: "#myblazon #coatofarm #heraldry #logo #personality" // Only the first one is accepted
                },
                function (response) {
                    if (response && !response.error_message) {
                        logShare("facebook", href, 1);
                    }
                }
            );
        });
    }

    $(".pinterest-share-button").click((e) => {
        const $this = $(e.currentTarget);
        const href = $this.data("href");
        logShare("pinterest", href, 0);
    });
});